<template>
  <div>
    <fei-shu-document-new :token="documentToken" />
  </div>
</template>

<script>
import { queryDocument } from '@/api/business/document';
import FeiShuDocumentNew from '@/components/FeiShu/DocumentNew';

export default {
  components: {
    FeiShuDocumentNew
  },
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      documentToken: null
    };
  },

  created() {
    this.getDocuments();
  },

  methods: {
    /**
     * 查询需求关联的文档
     */
    getDocuments() {
      queryDocument({
        objectId: this.sourceId,
        objectType: 'fault',
        pageNumber: 1,
        pageSize: 10,
        category: 'RCA'
      }).then(res => {
        this.documents = res.data.items.map((item, index) => ({ index, ...item }));
      });
    }
  }
};
</script>
